module.exports = __webpack_public_path__ + "img/choose.ff775928.svg";